export default __webpack_public_path__ + "static/media/opportunisticstrike.c57ae8d0.png";